import {
  IPrismicTitleMultiRowCardsButtonItem,
  ITitleMultiRowCardsButton,
  IItem,
} from './types';

export const mapTitleMultiRowCardsButton = ({
  prismicContent,
}): ITitleMultiRowCardsButton => {
  const items: IItem[] = prismicContent.items.map(
    (item: IPrismicTitleMultiRowCardsButtonItem) => {
      const {
        image: { url: image, alt },
      } = item;

      return {
        ...item,
        image,
        alt,
      };
    },
  );
  const {
    background_image: { url: backgroundImage },
    button_label: buttonLabel,
    internal_link: internalLink,
    external_link: externalLink,
  } = prismicContent.primary;

  const titleMultiRowCardsButton: ITitleMultiRowCardsButton = {
    ...prismicContent.primary,
    backgroundImage,
    buttonLabel,
    link: internalLink || externalLink!.url,
    items,
  };

  return titleMultiRowCardsButton;
};
